<template>
  <span
    class="i-layout-header-trigger i-layout-header-trigger-min i-layout-header-trigger-in"
  >
    <Notification
      :wide="isMobile"
      :badge-props="badgeProps"
      class="i-layout-header-notice"
      :class="{ 'i-layout-header-notice-mobile': isMobile }"
      :count="unreadTodo"
      @on-clear="handleClear"
      @on-load-more="handleLoadMore"
    >
      <audio controls muted autoplay id="noticeMessage" ref="audioPlayer">
        <source src="@/assets/noticeMessage.mp3" type="audio/mpeg" />
        您的浏览器不支持音频播放。
      </audio>
      <Icon
        id="noticeIcon"
        slot="icon"
        custom="i-icon i-icon-notification"
        :class="{ activeNotice: isActiveNotice }"
        @click="init"
      />
      <!-- <NotificationTab
        title="通知"
        name="message"
        :count="unreadMessage"
        :loaded-all="messageList.length >= count"
        :loading="messageLoading"
        :scroll-to-load="false"
      >
        <NotificationItem
          v-for="(item, index) in messageList"
          :key="index"
          :title="item.title"
          :icon="item.type"
          :icon-color="item.iconColor"
          :time="item.createTime"
          :read="item.read"
          @click.native="addtit1(item,index)"
        />
      </NotificationTab> -->
      <NotificationTab
        title="待办"
        name="todo"
        :count="unreadTodo"
        :loading="todoLoading"
        :loaded-all="todoList.length >= otherCount"
        :scroll-to-load="false"
      >
        <NotificationItem
          v-for="(item, index) in todoList"
          :key="index"
          :title="item.title"
          :time="item.createTime"
          :tag-props="item.tagProps"
          :read="item.read"
          @click.native="addtit2(item, index)"
        />
      </NotificationTab>
    </Notification>
    <Modal
      v-model="modal1"
      scrollable
      title="通知详情"
      @on-ok="ok1"
      :closable="false"
      :mask-closable="false"
    >
      <div v-html="content"></div>
      <Button slot="footer" @click="ok1" type="primary">确定</Button>
    </Modal>
    <Modal
      v-model="modal2"
      scrollable
      title="待办详情"
      @on-ok="ok2"
      :closable="false"
      :mask-closable="false"
    >
      <div v-html="content"></div>
      <Button slot="footer" @click="ok2" type="primary">确定</Button>
    </Modal>
  </span>
</template>
<script>
// :tag="item.type"   待办的状态   @click="openmodal"

import { mapState } from "vuex";

export default {
  props: ["title"],
  name: "iHeaderNotice",
  data() {
    return {
      isActiveNotice: false,
      badgeProps: {
        offset: [20, 0],
      },
      count: 0,
      otherCount: 0,
      number: 1,
      modal1: false,
      modal2: false,
      content: "",
      id: "",
      messageList: [],
      todoList: [],
      messageBaseList: [],
      todoBaseList: [],
      messageLoading: false,
      followLoading: false,
      todoLoading: false,
      unreadMessage: 0,
      unreadTodo: 0,
    };
  },
  computed: {
    ...mapState("admin/layout", ["isMobile"]),
    // unreadMessage() {
    //   let unread = 0;
    //   this.messageList.forEach(item => {
    //     if (item.status == "1") unread++;
    //   });
    //   return unread;
    // },

    // unreadTodo() {
    //   let unread = 0;
    //   this.todoList.forEach(item => {
    //     if (item.status == "1") unread++;
    //   });
    //   return unread;
    // },
  },
  created() {},
  mounted() {
    this.init();
    let that = this;
    // 通过用户交互解除限制
    document.body.addEventListener("click", () => {
      var player = document.getElementById("noticeMessage");
      player.muted = false;
    });
    this.$bus.$on("updateNoticeMessage", async () => {
      that.init().then(() => {
        that.isActiveNotice = true;
        // document.getElementById('noticeMessage').play();
      });
    });
  },
  methods: {
    playAudio() {
      this.$refs.audioPlayer.play();
    },
    async init() {
      this.isActiveNotice = false;
      // 初始加载待办 通知消息
      await this.abHttpUtil
        .get("/oa/oAInstationMsg/getInstationMsg?type=1&pageNo=1&pageSize=5")
        .then((res) => {
          if (this.todoList.length) {
            this.playAudio();
          }
          this.todoBaseList = res.data.resultList;
          this.todoList = this.todoBaseList;
          this.otherCount = res.data.count;
          this.unreadTodo = res.data.count;
        });

      await this.abHttpUtil
        .get("/oa/oAInstationMsg/getInstationMsg?type=2&pageNo=1&pageSize=5")
        .then((res) => {
          this.messageBaseList = res.data.resultList;
          this.messageList = this.messageBaseList;
          this.count = res.data.count;
          this.unreadMessage = res.data.count;

          for (var i = 0; i < this.messageList.length; i++) {
            if (this.messageList[i].type == "21") {
              this.$set(this.messageList[i], `type`, "md-star");
              this.$set(this.messageList[i], "iconColor", "#ff9900");
            }
            if (this.messageList[i].type == "22") {
              this.$set(this.messageList[i], `type`, "md-home");
              this.$set(this.messageList[i], "iconColor", "#87d068");
            }
            if (this.messageList[i].type == "23") {
              this.$set(this.messageList[i], `type`, "md-plane");
              this.$set(this.messageList[i], "iconColor", "#3391e5");
            }
          }
        });
    },
    addtit1(item, id) {
      this.modal1 = true;
      this.id = item.id;
      this.abHttpUtil
        .get(`/oa/oAInstationMsg/get?id=${this.id}`)
        .then((res) => {
          this.content = res.data.content;
        });
    },
    addtit2(item, id) {
      this.modal2 = true;
      this.id = item.id;
      this.abHttpUtil
        .get(`/oa/oAInstationMsg/get?id=${this.id}`)
        .then((res) => {
          this.content = res.data.content;
        });
    },
    ok1() {
      this.modal1 = false;
      this.abHttpUtil
        .post("oa/oAInstationMsg/save", {
          id: this.id,
          status: "2",
        })
        .then((res) => {
          this.$Message.success("消息已读");
          this.init();
          this.abHttpUtil
            .get(
              "/oa/oAInstationMsg/getInstationMsg?type=2&pageNo=1&pageSize=5"
            )
            .then((res) => {
              this.$emit("increase", res.data.totalCount);
              this.unreadMessage = res.data.count;
            });
        });
    },
    ok2() {
      this.modal2 = false;
      this.abHttpUtil
        .post("oa/oAInstationMsg/save", {
          id: this.id,
          status: "2",
        })
        .then((res) => {
          this.$Message.success("消息已读");
          this.init();
          this.abHttpUtil
            .get(
              "/oa/oAInstationMsg/getInstationMsg?type=1&pageNo=1&pageSize=5"
            )
            .then((res) => {
              this.$emit("increase", res.data.totalCount);
              this.unreadTodo = res.data.count;
            });
        });
    },
    handleLoadMore(tab) {
      this.loadMore(tab.name);
    },
    loadMore(type) {
      if (this[`${type}Loading`]) return;
      this[`${type}Loading`] = true;
      if (type == "message") {
        this.number += 1;

        this.abHttpUtil
          .get(
            `/oa/oAInstationMsg/getInstationMsg?type=2&pageNo=${this.number}&pageSize=5`
          )
          .then((res) => {
            this.messageList = res.data.resultList;
            for (var i = 0; i < this.messageList.length; i++) {
              if (this.messageList[i].type == "21") {
                this.$set(this.messageList[i], `type`, "md-star");
                this.$set(this.messageList[i], "iconColor", "#ff9900");
              }
              if (this.messageList[i].type == "22") {
                this.$set(this.messageList[i], `type`, "md-home");
                this.$set(this.messageList[i], "iconColor", "#87d068");
              }
              if (this.messageList[i].type == "23") {
                this.$set(this.messageList[i], `type`, "md-plane");
                this.$set(this.messageList[i], "iconColor", "#3391e5");
              }
            }
            this[`${type}Loading`] = false;
          });
      } else {
        this.number += 1;
        this.abHttpUtil
          .get(
            `/oa/oAInstationMsg/getInstationMsg?type=1&pageNo=${this.number}&pageSize=5`
          )
          .then((res) => {
            this.todoList = res.data.resultList;
            this[`${type}Loading`] = false;
          });
      }
    },
    handleClear(tab) {
      this.clearUnread(tab.name);
    },
    clearUnread(type) {
      // 改变状态
      // item.status = 2;

      var length = this[`${type}List`].length;
      var arr = [];
      for (var i = 0; i < length; i++) {
        arr[i] = this[`${type}List`][i].id;
        this[`${type}List`][i].status == 2;
      }
      var str = arr.toString();
      // 调用删除的接口 批量阅读删除
      this.abHttpUtil.post(`oa/oAInstationMsg/remove?id=${str}`).then((res) => {
        this.$Message.success("标记已读成功！");
        this[`${type}List`] = this[`${type}List`].map((item) => {
          item.status = 2;
          return item;
        });
        this.init();
        if (type == "message") {
          this.abHttpUtil
            .get(
              "/oa/oAInstationMsg/getInstationMsg?type=2&pageNo=1&pageSize=5"
            )
            .then((res) => {
              this.$emit("increase", res.data.totalCount);
            });
        } else {
          this.abHttpUtil
            .get(
              "/oa/oAInstationMsg/getInstationMsg?type=1&pageNo=1&pageSize=5"
            )
            .then((res) => {
              this.$emit("increase", res.data.totalCount);
            });
        }
      });
    },
  },
};
</script>

<style>
@keyframes animated-border {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  100% {
    box-shadow: 0 0 0 20px rgba(255, 255, 255, 1);
  }
}

.activeNotice {
  animation: animated-border 1s infinite;
  /*animation: shake-slow 10s infinite;*/
}
#noticeIcon {
  width: 2em;
  display: inline-block;
  position: relative;
  line-height: 64px;
}
#noticeMessage {
  display: none;
}
</style>
